import type { ToasterProps } from 'sonner'

import { Toaster as Sonner } from 'sonner'

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group light"
      // style={
      //   {
      //     '--normal-bg': 'var(--popover)',
      //     '--normal-text': 'var(--popover-foreground)',
      //     '--normal-border': 'var(--border)',
      //   } as React.CSSProperties
      // }
      richColors
      {...props}
    />
  )
}

export { Toaster }
